var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFintoolslogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_615_157",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 800,
    height: 800
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    rx: 200,
    fill: "url(#paint0_linear_615_157)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_615_157)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "url(#paint1_linear_615_157)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_615_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.286 321.527L394.571 284.217C391.607 282.653 387.936 283.821 386.42 286.81L212.331 630.139C210.856 633.048 211.974 636.602 214.849 638.142L274.439 670.065C277.34 671.619 280.952 670.546 282.534 667.66L467.748 329.717C469.358 326.779 468.25 323.091 465.286 321.527Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.594 224.559L593.515 247.139C595.162 248.52 597.422 248.915 599.439 248.174L618.049 241.337C619.715 240.725 621.567 240.882 623.106 241.766L669.787 268.564C672.535 270.142 673.583 273.586 672.178 276.427L633.514 354.634C631.978 357.741 628.136 358.904 625.134 357.17L574.801 328.098C573.44 327.312 572.442 326.023 572.021 324.509L566.398 304.266C565.677 301.669 563.312 299.872 560.617 299.872H517.634C516.362 299.872 515.124 300.276 514.097 301.025L481.725 324.648C479.862 326.007 477.385 326.179 475.352 325.089L378.821 273.326C376.627 272.149 375.388 269.74 375.706 267.271L384.806 196.638C385.268 193.05 382.473 189.872 378.855 189.872H296.708C296.355 189.872 296.002 189.903 295.655 189.965L236.635 200.488C233.768 200.999 230.948 199.378 229.947 196.642L226.001 185.857C224.96 183.01 226.205 179.834 228.904 178.454L288.846 147.797C289.397 147.515 289.988 147.32 290.599 147.219L352.691 136.952C353.015 136.898 353.342 136.872 353.67 136.872H427.152C427.831 136.872 428.504 136.987 429.144 137.212L550.241 179.838C552.082 180.486 553.493 181.989 554.023 183.867L564.675 221.593C565.002 222.752 565.671 223.785 566.594 224.559Z",
    fill: "#D14343",
    stroke: "#D14343",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.365 172.75C563.72 176.857 564.785 180.515 565.976 192.237C568.067 211.086 575.879 224.896 589 233.015C595.821 237.287 595.882 237.17 600.504 234.529C606.434 231.084 616.919 229.699 625.845 231.054C631.533 232.072 636.975 234.441 657.23 245.366C684.024 259.674 684.488 260.212 686.282 271.056C686.984 275.419 686.376 276.881 664.201 319.743C642.026 362.604 641.184 363.945 637.218 365.892C635.026 366.981 631.129 368.221 628.711 368.598C624.466 369.361 622.652 368.571 597.195 355.4L570.102 341.384L564.684 333.25C561.339 328.264 558.771 322.638 558.24 318.52C557.377 312.744 556.631 311.615 552.426 309.439C534.74 299.843 509.046 307.722 495.498 326.768C492.975 330.495 489.749 334.157 488.387 335.08C484.289 337.844 476.039 339.203 471.296 337.783L466.847 336.366L377.916 507.686C288.987 678.716 288.805 679.067 284.724 680.949C282.532 682.037 278.635 683.277 276.217 683.654C271.972 684.417 270.275 683.688 236.878 666.409C203.476 649.128 201.9 648.165 200.076 644.262C198.987 642.07 197.747 638.173 197.37 635.755C196.551 631.332 196.73 630.986 284.896 459.709L373.3 288.259L368.888 284.2C360.64 276.677 360.632 272.971 369.621 235.278C374.11 216.875 377.564 201.044 377.635 200.047C377.648 198.871 373.725 197.875 364.153 196.922C329.328 193.267 290.395 197.553 246.296 209.826C236.97 212.405 231.722 213.094 228.507 212.167C215.098 208.04 208.941 193.904 215.285 181.642C217.703 176.968 230.3 167.793 247.96 157.683C323.872 114.5 408.791 110.315 502.238 144.893C522.598 152.468 557.359 169.121 560.365 172.75ZM493.97 164.307C413.164 134.492 339.872 135.66 273.378 168.03C260.118 174.491 236.87 188.52 235.721 190.742C235.417 191.328 240.49 190.102 247.048 188.016C296.064 173.106 364.264 170.343 396.861 182.026L403.18 184.411L402.051 189.453C401.308 192.325 397.371 209.089 393.183 226.911C388.995 244.734 384.946 261.439 384.436 264.135L383.307 269.178L429.787 293.225L476.15 317.211L481.237 310.811C494.053 294.344 516.783 283.602 537.592 284.302C548.758 284.748 549.582 284.878 564.592 292.204L580.135 299.651L578.775 304.277C577.049 309.897 578.936 318.277 582.867 322.979C584.949 325.535 591.597 329.569 606.31 337.181L626.747 347.755L646.082 310.382L665.417 273.009L644.98 262.436C630.267 254.824 623.134 251.728 619.844 251.506C613.796 250.896 605.808 254.31 602.276 258.852L599.457 262.576L586.961 256.111C572.945 248.86 564.806 242.277 558.347 232.721C552.924 224.883 545.687 204.256 544.765 194.011L543.995 186.06L526.403 177.992C516.663 173.379 502.044 167.295 493.97 164.307ZM305.206 465.63L218.2 633.804L246.231 648.306L274.261 662.808L361.268 494.634L448.274 326.46L420.243 311.958L392.213 297.456L305.206 465.63Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_615_157",
    x: 187.236,
    y: 121.78,
    width: 509.208,
    height: 592.066,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_615_157"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_615_157",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_615_157",
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 800,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_615_157",
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 800,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFintoolslogo);
export default __webpack_public_path__ + "static/media/fintoolslogo.59f191ccc8400edb86fe96bbd2e11525.svg";
export { ForwardRef as ReactComponent };